import { i18n } from "@lingui/core";
import { useEffect } from "react";

import { activateLocale, type Locale } from "@/shared/i18n";

// После входа язык интерфейса берётся из профиля. Срабатывает, когда язык в профиле
// меняется (первая загрузка или ответ `PATCH /api/me`), а не на каждое переключение Lingui:
// иначе выбор пользователя откатывался бы до ответа сервера.
export const useProfileLocale = (profileLocale: Locale | undefined): void => {
  useEffect(() => {
    if (profileLocale !== undefined && profileLocale !== i18n.locale) {
      void activateLocale(profileLocale);
    }
  }, [profileLocale]);
};
